<template>
  <div class="wf-search-results-page">
    <template>
      <div class="wf-search-results-page-header">
        <div class="wf-search-results-page-title">
          search results for "{{ searchTerm }}":
        </div>
      </div>
      <div class="wf-anchor-bar">
        <anchor-bar-item
          v-for="scopeOption in scopeOptions"
          :key="scopeOption.id"
          :anchor="'#' + scopeOption.id"
          :title="scopeOption.title"
          :id="scopeOption.id"
        />
      </div>
      <results-collections v-show="isCollectionsTab" />
      <keep-alive>
        <product-search-page v-if="isStylesTab" />
      </keep-alive>
      <results-pages v-show="isPagesTab" />
    </template>
    <product-compare-container />
    <product-compare-modal />
    <product-compare-download />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AnchorBarItem from "./pc-anchor-bar-item.vue";
import ProductSearchPage from "../product-search/pc-product-search-container.vue";
import ProductCompareContainer from "../product-search/pc-product-compare.vue";
import ProductCompareModal from "../product-search/pc-product-compare-modal.vue";
import ProductCompareDownload from "../product-search/pc-product-compare-download.vue";
import ResultsCollections from "./pc-search-results-collections.vue";
import ResultsPages from "./pc-search-results-pages.vue";

export default {
  components: {
    AnchorBarItem,
    ProductSearchPage,
    ProductCompareContainer,
    ProductCompareModal,
    ProductCompareDownload,
    ResultsCollections,
    ResultsPages
  },
  computed: {
    ...mapGetters({
      selectedTab: "searchResultsPage/selectedTab",
      searchTerm: "searchResultsPage/searchTerm"
    }),
    isCollectionsTab() {
      return this.selectedTab === "collections";
    },
    isPagesTab() {
      return this.selectedTab === "page-content";
    },
    isStylesTab() {
      return this.selectedTab === "styles";
    }
  },
  data() {
    return {
      scopeOptions: this.$config.search.resultScopeOptionsNew
    };
  },
  methods: {
    ...mapActions({
      setSearchTerm: "searchResultsPage/setSearchTerm",
      setSelectedTab: "searchResultsPage/setSelectedTab"
    })
  },
  mounted() {
    const searchWord = new URLSearchParams(window.location.search)?.get(
      "searchTerm"
    );
    const selectedTab = new URLSearchParams(window.location.search)?.get("tab");
    if (searchWord) {
      this.setSearchTerm(searchWord);
    }
    if (selectedTab) {
      this.setSelectedTab(selectedTab);
    }
  }
};
</script>

<style></style>
